import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage, withFormik } from 'formik';
import * as yup from 'yup';
import { Row, Col } from 'react-bootstrap';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import Heading from '../../heading/Heading';
import { FormCheckbox, FormInput, FormSelect, FormInputAhead } from '../elements';
export default (function (props) {
  var changeHandler = props.changeHandler,
      receiptNumber = props.receiptNumber,
      setFieldValue = props.setFieldValue,
      subject = props.subject,
      _props$feedbackConcer = props.feedbackConcern,
      feedbackConcern = _props$feedbackConcer === void 0 ? "feedbackConcern" : _props$feedbackConcer,
      feedbackText = props.feedbackText,
      _props$terms = props.terms,
      terms = _props$terms === void 0 ? {} : _props$terms,
      _props$privacy = props.privacy,
      privacy = _props$privacy === void 0 ? {} : _props$privacy,
      values = props.values;
  useEffect(function () {
    setFieldValue(feedbackConcern, "Online Retail Order");
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: "How can we help?"
    },
    className: "cb-type__title"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.receiptNumber,
    name: "receiptNumber",
    label: "Order Number",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.feedbackText,
    name: "feedbackText",
    label: "What would you like us to know?",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))));
});